<template>
  <v-simple-table fixed-header>
    <template v-slot:default>
      <thead>
        <tr>
          <th :colspan="3" class="grey lighten-2 font-weight-bold subtitle-1">
            <div class="row">
              <span>文法解説</span>
              <v-spacer />
              <SelectGrammar @resetList="handleGetListGrammar" />
              <!-- add legal information-->
              <v-btn
                :to="{
                  name: 'Add Grammar OF Section',
                  params: { section: $route.params.section },
                }"
                class="mx-3"
                small
                color="primary"
                >追加</v-btn
              >
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <v-data-iterator
              :items-per-page.sync="listGrammar.length"
              :items="listGrammar"
              :loading="loadingListGrammar"
              hide-default-footer
            >
              <template v-slot:default="props">
                <v-row>
                  <v-col
                    v-for="(item, index) in props.items"
                    :key="index"
                    cols="2"
                    class="card-list"
                  >
                    <v-card color="#f5f5f5">
                      <v-card-text class="align-start py-2 mt-1">
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <span
                              class="d-inline-block text-truncate"
                              style="max-width: 150px"
                              v-bind="attrs"
                              v-on="on"
                            >
                              <template v-for="field in item.data">
                                <span
                                  :key="field.id"
                                  v-if="field.key == 'Title'"
                                  class="px-2"
                                  >{{ field.value.ja }}</span
                                >
                              </template>
                            </span>
                          </template>
                          <span>
                            <template v-for="field in item.data">
                              <span
                                :key="field.id"
                                v-if="field.key == 'Title'"
                                class="px-2"
                                >{{ field.value.ja }}</span
                              >
                            </template>
                          </span>
                        </v-tooltip>
                        <div class="row pa-0 ma-0">
                          <div class="icon-trash">
                            <v-icon
                              size="medium"
                              v-text="`fas fa-pencil-alt`"
                              class="mr-3"
                              @click="
                                $router.push({
                                  name: 'Update Grammar OF Section',
                                  params: {
                                    section: $route.params.section,
                                    grammar: item.Id,
                                  },
                                })
                              "
                            />
                            <DeleteItemGrammar
                              :item="item"
                              @resetList="handleGetListGrammar"
                            />
                          </div>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </template>
              <template v-slot:loading>
                <div class="text-center mt-5">
                  読み込み中。。。待ってください。
                </div>
              </template>
              <template v-slot:no-data>
                <div class="text-center mt-5">データがありません。</div>
              </template>
            </v-data-iterator>
          </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>
<script>
import { getListGrammar } from "@/api/Grammar.api";
import DeleteItemGrammar from "@/views/listSection/Grammar/DeleteItemGrammar.vue";
import SelectGrammar from "@/views/listSection/Grammar/SelectGrammar.vue";
export default {
  store: ["editDetailSection"],
  components: {
    DeleteItemGrammar,
    SelectGrammar,
  },
  data() {
    return {
      defaultListGrammar: [],
      listGrammar: [],
      loading: false,
      loadingListGrammar: false,
    };
  },
  watch: {
    $route: function () {
      this.handleGetListGrammar();
    },
  },
  created() {
    this.handleGetListGrammar();
    console.log(" $route: ", this.$route.params.section);
  },
  methods: {
    async handleGetListGrammar() {
      this.loadingListGrammar = true;
      let params = {
        keyword: "",
        sub_key: this.$route.params.section,
      };
      this.loadingListGrammar = true;
      await getListGrammar(params)
        .then(({ result }) => {
          this.defaultListGrammar = result;
          this.listGrammar = result;
        })
        .catch((error) => {
          console.log(error);
        });
      this.loadingListGrammar = false;
    },
  },
};
</script>
<style  scoped>
::v-deep tr td {
  border: 1px solid #ccc;
  border-top: none;
}
::v-deep tr th {
  border: 1px solid #ccc;
  border-bottom: none;
}
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  background: #ffffff !important;
}
</style>